__turbopack_context__.v({
  "active": "Kenniscentrum-module-scss-module__6aAqlq__active",
  "btnIcon": "Kenniscentrum-module-scss-module__6aAqlq__btnIcon",
  "checkWithCount": "Kenniscentrum-module-scss-module__6aAqlq__checkWithCount",
  "filterBtn": "Kenniscentrum-module-scss-module__6aAqlq__filterBtn",
  "filterSluiten": "Kenniscentrum-module-scss-module__6aAqlq__filterSluiten",
  "filterTekst": "Kenniscentrum-module-scss-module__6aAqlq__filterTekst",
  "filters": "Kenniscentrum-module-scss-module__6aAqlq__filters",
  "headerFilters": "Kenniscentrum-module-scss-module__6aAqlq__headerFilters",
  "icon": "Kenniscentrum-module-scss-module__6aAqlq__icon",
  "kenniscentrumHeaderContainer": "Kenniscentrum-module-scss-module__6aAqlq__kenniscentrumHeaderContainer",
  "laasteItemBox": "Kenniscentrum-module-scss-module__6aAqlq__laasteItemBox",
  "line": "Kenniscentrum-module-scss-module__6aAqlq__line",
  "meer": "Kenniscentrum-module-scss-module__6aAqlq__meer",
  "nonActive": "Kenniscentrum-module-scss-module__6aAqlq__nonActive",
  "resetFilterIcon": "Kenniscentrum-module-scss-module__6aAqlq__resetFilterIcon",
  "resetFilters": "Kenniscentrum-module-scss-module__6aAqlq__resetFilters",
  "subCheck": "Kenniscentrum-module-scss-module__6aAqlq__subCheck",
  "teller": "Kenniscentrum-module-scss-module__6aAqlq__teller",
  "terugButton": "Kenniscentrum-module-scss-module__6aAqlq__terugButton",
  "title": "Kenniscentrum-module-scss-module__6aAqlq__title",
  "toggle": "Kenniscentrum-module-scss-module__6aAqlq__toggle",
  "totals": "Kenniscentrum-module-scss-module__6aAqlq__totals",
  "weergaveMenu": "Kenniscentrum-module-scss-module__6aAqlq__weergaveMenu",
});
